import React from 'react'
import {
  CLickFunnelsTag,
  useTestTag,
} from 'organization/Event/Services/Apps/ClickFunnels/Config/Tags'
import {CLICK_FUNNELS} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestClickFunnelsTagButton(props: {
  tag: CLickFunnelsTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton
      tag={props.tag}
      integration={CLICK_FUNNELS}
      addTag={addTag}
    />
  )
}
